module.exports = __webpack_public_path__ + "img/en.6f60ffea.svg";